<template>
  <div
    v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')"
  >
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết thông tin liên hệ</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/contact')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
        <b-link
          target="_blank"
          :to="`/customer-support/contact/${id}/edit`"
          class="font-medium f12 btn btn-outline-primary m-r-10"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          Cập nhật
        </b-link>
      </div>
      <hr />
    </div>

    <b-row class="gx-4 px-20">
      <!-- Box 1: Thông tin chung -->
      <b-col cols="6" md="6">
        <b-card class="shadow-card mb-3" title="Thông tin chung">
          <template v-if="!isLoading">
            <!-- Hiển thị tất cả các thông tin trừ các danh sách -->
            <div
              class="form-group form-row pl-2"
              v-for="(value, key) in formattedInfo"
              :key="key"
            >
              <label for="" class="col-sm-4 col-form-label"
                >{{ key }} <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ value }}</p>
              </div>
            </div>
            <!-- Hiển thị trạng thái dưới dạng thẻ tag -->
            <!-- <div class="form-group form-row pl-2" v-if="info.status">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <b-badge class="mt-1" :variant="statusColor">{{
                  info.status
                }}</b-badge>
              </div>
            </div> -->
          </template>
          <template v-else>
            <div class="spinner-center">
              <b-spinner class="align-middle" />
            </div>
          </template>
        </b-card>
        <b-card class="shadow-card h-340" title="Danh sách Merchant Owner">
          <div v-if="!isLoading">
            <b-table
              show-empty
              bordered
              hover
              fixed
              responsive
              sticky-header
              head-variant="light"
              :items="info.moContacts"
              :fields="contactFields"
            >
              <template #cell(name)="{ item }">
                <b-link
                  class="text-primary font-medium"
                  target="_blank"
                  :to="`/customer-support/merchant-owner/${item.id}`"
                >
                  {{ item.name || item.email }}
                </b-link>
              </template>
              <template #cell(role)="{ item }">
                <p>
                  {{ getNameMa(item.role) }}
                </p>
              </template>
              <template #empty>
                <div class="text-center text-secondary my-2">
                  Không có dữ liệu
                </div>
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
      <b-col cols="6" class="pl-0" md="6">
        <b-card
          class="shadow-card mb-3 h-290"
          title="Danh sách Merchant Account"
        >
          <div v-if="!isLoading">
            <b-table
              bordered
              show-empty
              hover
              fixed
              sticky-header
              responsive
              head-variant="light"
              :items="info.maContacts"
              :fields="contactFields"
            >
              <template #cell(name)="{ item }">
                <b-link
                  class="text-primary font-medium"
                  target="_blank"
                  :to="`/customer-support/account/${item.id}`"
                >
                  {{ item.name || item.email }}
                </b-link>
              </template>
              <template #cell(role)="{ item }">
                <p>
                  {{ getNameMa(item.role) }}
                </p>
              </template>
              <template #empty>
                <div class="text-center text-secondary my-2">
                  Không có dữ liệu
                </div>
              </template>
            </b-table>
          </div>
        </b-card>
        <b-card class="shadow-card h-290" title="Danh sách cửa hàng">
          <div v-if="!isLoading">
            <b-table
              bordered
              hover
              fixed
              show-empty
              responsive
              sticky-header
              head-variant="light"
              :items="info.storeContacts"
              :fields="contactFields"
            >
              <template #cell(name)="{ item }">
                <b-link
                  class="text-primary font-medium"
                  target="_blank"
                  :to="`/customer-support/store/${item.id}`"
                >
                  {{ item.name || item.email }}
                </b-link>
              </template>
              <template #cell(role)="{ item }">
                <p>{{ getNameStore(item.role) }}</p>
              </template>
              <template #empty>
                <div class="text-center text-secondary my-2">
                  Không có dữ liệu
                </div>
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Detail } from "@/services/customer-support/contact";
import { showMess } from "@/config/utils";
import { CommonService } from "@/services/common.service";

export default {
  data() {
    return {
      moList: [],
      maList: [],
      storeList: [],
      isLoading: false,
      id: "",
      info: {},
      // Cấu trúc bảng với các cột mong muốn
      contactFields: [
        { key: "name", label: "Tên", thStyle: { width: "auto" } },
        // { key: "email", label: "Email" },
        // { key: "address", label: "Địa chỉ" },
        { key: "role", label: "Chức danh", thStyle: { width: "40%" } },
        // { key: "region", label: "Khu vực" },
        // { key: "referCode", label: "Mã" },
      ],
    };
  },

  created() {
    this.id = this.$router.currentRoute.params.id;
  },

  async mounted() {
    await this.configSystem();
    this.loadData();
  },

  computed: {
    ...mapGetters({
      dataPermission: "role/dataPermission",
    }),
    formattedInfo() {
      // Định dạng lại các giá trị như ngày tháng và text
      return {
        // Mã: this.info.id,
        // "Phiên bản": this.info.version,
        // "Tạo bởi": this.info.createdBy,
        Tên: this.info.name,
        Email: this.info.email,
        "Số điện thoại": this.info.mobile,
        "Người tạo": this.info.createdByName,
        "Người cập nhật": this.info.lastModifiedByName,
        "Ngày tạo": this.formatDateTime(this.info.createdDate),
        "Ngày cập nhật": this.formatDateTime(this.info.lastModifiedDate),
        // "Tìm kiếm": this.formatTextSearch(this.info.textSearch),
      };
    },
    statusColor() {
      // Đặt màu cho trạng thái dựa vào giá trị status
      switch (this.info.status) {
        case "NEW":
          return "primary";
        case "ACTIVE":
          return "success";
        case "INACTIVE":
          return "secondary";
        default:
          return "light";
      }
    },
    getNameMo() {
      return (code) => {
        const found = this.moList.find((item) => item.code === code);
        return found ? found.name : code;
      };
    },
    getNameMa() {
      return (code) => {
        const found = this.maList.find((item) => item.code === code);
        return found ? found.name : code;
      };
    },
    getNameStore() {
      return (code) => {
        const found = this.storeList.find((item) => item.code === code);
        return found ? found.name : code;
      };
    },
  },

  methods: {
    async configSystem() {
      try {
        const res = await CommonService.getConfigSystem();
        this.moList = res.data.moContact;
        this.maList = res.data.maContact;
        this.storeList = res.data.storeContact;
        console.log("this.storeMap", this.storeMap);
      } catch (e) {
        showMess(
          this,
          "Error",
          e.response?.data?.message || e.response?.message || e.message,
          "danger",
          "b-toaster-top-right",
          5 * 60 * 60
        );
      }
    },
    async loadData() {
      try {
        this.isLoading = true;
        const res = await Detail(this.id);
        this.info = res.data;
      } catch (e) {
        showMess(
          this,
          "Lỗi",
          e.message,
          "danger",
          "b-toaster-top-right",
          5 * 60 * 60
        );
      } finally {
        this.isLoading = false;
      }
    },
    formatDateTime(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      // const seconds = date.getSeconds().toString().padStart(2, "0");

      // Trả về định dạng ngày/tháng/năm giờ:phút:giây
      return `${hours}:${minutes} ${day}/${month}/${year} `;
    },
    formatTextSearch(text) {
      return text ? text.split(" ").join(", ") : "";
    },
  },
};
</script>
<style scoped>
.breadcrumb {
  margin-bottom: 0;
}
.h-fit {
  height: fit-content !important;
}
.shadow-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* margin-bottom: 20px; */
  border-radius: 10px;
  border: 0.1px solid #e4e4e4;
}
.min-h-290 {
  min-height: 290px;
}
.h-340 {
  height: 340px;
}
.h-340 .b-table-sticky-header {
  max-height: 36.5svh !important;
}
.card-footer {
  background-color: #fff;
  border-top: none !important;
}
.b-table-sticky-header {
  min-height: 29.5svh;
  max-height: 29.5svh;
}

.card-title {
  font-size: 16px !important;
  font-weight: bold;
  padding-bottom: 10px;
}
.b-table-sticky-header {
  border-radius: 0 !important;
}
.form-control-plaintext,
.col-form-label {
  padding: 0.175rem !important;
}

.spinner-center {
  display: flex;
  justify-content: center;
}
.form-group {
  margin-bottom: 0 !important;
}
.table td {
  background: white !important;
}

.b-badge {
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
}
</style>
